import React from 'react';
import InventoryList from './InventoryList';
import { sharedPrintStyles, basePrintContainerStyle } from './printStyles';

const PrintPreview: React.FC = () => {
  const sampleData = {
    voyageNo: 'EI08CAN',
    date: '26.11.2025',
    shipName: 'E. ISTANBUL 08 CYB',
    loadingPort: 'Antwerp',
    cars: [
      {
        position: 1,
        dealer: '727',
        port: 'ALE',
        consignee: 'AHMED RABIE ABU BAKR JUNAI',
        chassisNo: 'L53229',
        make: 'BMW',
        model: '316',
        type: 'P'
      }
    ]
  };

  return (
    <div style={styles.page}>
      <style>{combinedPrintStyles}</style>
      <div style={styles.controls} className="no-print">
        <button onClick={() => window.print()} style={styles.button}>
          Print / Save as PDF
        </button>
      </div>
      <InventoryList {...sampleData} />
    </div>
  );
};

const printStyles = `
  @media print {
    .no-print { display: none !important; }
    body { background: white !important; }
  }
`;

const combinedPrintStyles = `${sharedPrintStyles}\n${printStyles}`;

const styles: { [key: string]: React.CSSProperties } = {
  page: {
    ...basePrintContainerStyle,
    backgroundColor: '#fff',
    minHeight: '100vh',
  },
  controls: {
    padding: '20px',
    textAlign: 'center',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #ddd',
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
  },
};

export default PrintPreview;

